import BaseAPI from '../base'

function getStoplist(menu_id) {
    return BaseAPI.sendGet(`stoplist/items/${menu_id}`);
}

function addToStoplist(menu_id, product_id) {
    return BaseAPI.sendPost(`stoplist/add/${menu_id}/${product_id}`);
}

function removeFromStoplist(menu_id, product_id) {
    return BaseAPI.sendPost(`stoplist/remove/${menu_id}/${product_id}`);
}

export default {
    getStoplist,
    addToStoplist,
    removeFromStoplist
}